import { useNavigate } from 'react-router-dom';
import HelpPageComponent from '../components/HelpPage';
import { useAppContext } from '../context/AppContext';
import { ROUTES } from '../navigation';

function HelpPage() {
  const navigate = useNavigate();
  const { currentUser, userName, handleLogout } = useAppContext();

  return (
    <HelpPageComponent
      onClose={() => {
        if (currentUser) {
          navigate(ROUTES.ACCOUNT);
        } else {
          navigate(ROUTES.HOME);
        }
      }}
      onOpenChat={() => navigate(ROUTES.CHAT)}
      showChatbot={false}
      onCloseChat={() => {}}
      userName={userName}
      userPhone={currentUser?.phoneNumber}
      onOpenOrders={() => navigate(ROUTES.ORDERS)}
      onOpenAddresses={() => navigate(ROUTES.ADDRESSES)}
      onLogout={handleLogout}
    />
  );
}

export default HelpPage;
